import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { formatPrice } from '@utils/format';
import styles from './OrderDetailAccordionButton.module.css';

interface OrderDetailAccordionButtonProps {
    title: string;
    itemsCount?: number;
    total?: number;
}

export const OrderDetailAccordionButton: FC<OrderDetailAccordionButtonProps> = ({ title, itemsCount, total }) => {
    const { t } = useTranslation();

    const translations = {
        totalLabel: t('my-order-detail-component.total.label'),
    };

    return (
        <div className={styles['order-management-item']}>
            <div className="col-5 d-flex">
                <Typography classes="d-inline-block mb-0" fontWeight="900" fontSize="20">
                    {title}
                </Typography>
                {itemsCount !== undefined && (
                    <Typography
                        classes="ms-2 align-content-center"
                        color="muted"
                        fontSize="16"
                        tagVariant={TypographyTagVariants.span}>
                        <>({itemsCount})</>
                    </Typography>
                )}
            </div>
            {total !== undefined && (
                <div className={`${styles['total-container']} col-7 pe-3`}>
                    <Typography
                        color="muted"
                        tagVariant={TypographyTagVariants.span}
                        fontSize="14"
                        breakpointsStyles={{ lg: { fontSize: '16' } }}>
                        {translations.totalLabel}
                    </Typography>
                    <Typography
                        classes="ms-2"
                        tagVariant={TypographyTagVariants.span}
                        fontWeight="800"
                        fontSize="14"
                        breakpointsStyles={{ lg: { fontSize: '16' } }}>
                        {formatPrice(total)}
                    </Typography>
                </div>
            )}
        </div>
    );
};
